import ExamsAdminPage from './ExamsAdminPage'
import { examsAdminMenu } from './sideBarOption'

export { examsAdminMenu }
export default ExamsAdminPage
